import $ from "jquery";
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Scrollbar]);

function initTestimonialsSlider($slider) {
  var $slides = $slider.find('.testimonials__slides');
  var $prev = $slider.find('.testimonials__prev');
  var $next = $slider.find('.testimonials__next');

  var swiper = new Swiper($slides[0], {
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      1180: {
        slidesPerView: 1,
      }
    },
    navigation: {
      nextEl: $next[0],
      prevEl: $prev[0],
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  $('.go-to-next-slide').on('click', function(e){
    e.preventDefault();
    swiper.slideNext();
  });

  return swiper;
}

$('.testimonials').each(function(){
  var $slider = $(this);
  var swiper = initTestimonialsSlider($slider);

  $(window).on('resize', function() {
    console.log('swiper resized..');
    swiper.destroy(true, true);
    swiper = initTestimonialsSlider($slider);
  });
});
